(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/expandable-area/assets/javascripts/expandable-area.js') >= 0) return;  svs.modules.push('/components/tipsen/expandable-area/assets/javascripts/expandable-area.js');
"use strict";

const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo;
const ExpandableArea = _ref => {
  let _ref$arrowPosition = _ref.arrowPosition,
    arrowPosition = _ref$arrowPosition === void 0 ? 0 : _ref$arrowPosition,
    children = _ref.children,
    className = _ref.className,
    dataTestId = _ref['data-testid'],
    id = _ref.id,
    isOpen = _ref.isOpen,
    isCouponMenu = _ref.isCouponMenu;
  const expandableAreaClassNames = useMemo(() => {
    const _expandableAreaClassNames = ['expandable-area'].concat(className !== null && className !== void 0 ? className : []);
    if (isOpen) {
      _expandableAreaClassNames.push('expandable-area-open');
      if (isCouponMenu) {
        _expandableAreaClassNames.push('expandable-area-coupon-menu');
      }
    }
    return _expandableAreaClassNames;
  }, [isOpen, className]);
  const expandableAreaRef = useRef();
  useEffect(() => {
    expandableAreaRef.current.style.setProperty('--arrow-position', "".concat(arrowPosition, "px"));
  }, [arrowPosition]);
  return React.createElement("div", {
    className: expandableAreaClassNames.join(' '),
    "data-testid": dataTestId,
    id: id || 'expandable-area',
    ref: expandableAreaRef
  }, children);
};
setGlobal('svs.components.tipsen.expandableArea.ExpandableArea', ExpandableArea);

 })(window);